import './loading-fadein.scss';

function LoadingFadeIn() {
  const loadingContainer = document.getElementById('loading_container');
  const mainContainer = document.getElementById('main_container');
  const isHomePage = document.querySelector('body').classList.contains('home');

  if (!loadingContainer || !mainContainer) return;

  // 初期表示のための設定
  mainContainer.style.visibility = 'visible';
  mainContainer.style.opacity = '1';

  if (isHomePage && !localStorage.getItem('homeLoaded')) {
    loadingContainer.style.display = 'flex';

    // DOMContentLoadedを使用してより早く処理を開始
    document.addEventListener('DOMContentLoaded', () => {
      requestAnimationFrame(() => {
        mainContainer.classList.add('fade-in');

        setTimeout(() => {
          loadingContainer.classList.add('fade-out');
          setTimeout(() => {
            loadingContainer.style.display = 'none';
          }, 500);
        }, 1000); // ローディング表示時間を短縮
      });
    });

    localStorage.setItem('homeLoaded', 'true');
  } else {
    requestAnimationFrame(() => {
      mainContainer.classList.add('fade-in');
    });
  }
}

LoadingFadeIn();
